var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinGalleryIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4852",
    "data-name": "Rectangle 4852",
    width: 12.556,
    height: 21.531,
    fill: "#111"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13963",
    "data-name": "Group 13963",
    transform: "translate(-1576 -306)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11966",
    "data-name": "Group 11966",
    transform: "translate(1576 306)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_420",
    "data-name": "Ellipse 420",
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "#111",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 17.75,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13221",
    "data-name": "Group 13221",
    transform: "matrix(0.966, 0.259, -0.259, 0.966, 1591.016, 311.526)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12160",
    "data-name": "Group 12160",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45224",
    "data-name": "Path 45224",
    d: "M6.953,0a7.481,7.481,0,0,1,3.192.824,1.309,1.309,0,0,1,.592,1.509A4.619,4.619,0,0,1,9.023,5.324l.409,2.857c1.559.987,4.205,3.569,2.65,5.506a3.384,3.384,0,0,1-1.649.959,12.681,12.681,0,0,1-3.355.577l-.34,5.863a.459.459,0,0,1-.918,0l-.34-5.863a12.887,12.887,0,0,1-3.261-.545A2.784,2.784,0,0,1,.11,13a2.867,2.867,0,0,1,.711-2.672A8.285,8.285,0,0,1,3.128,8.181l.409-2.857A4.636,4.636,0,0,1,1.928,2.86a2.789,2.789,0,0,1-.042-1.472C2.3.4,4.671.051,5.607,0Z",
    transform: "translate(0)",
    fill: "#111"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinGalleryIcon);
export default __webpack_public_path__ + "static/media/pin_gallery_icon.8a94eaee1d5519bc25b098f2faa3770d.svg";
export { ForwardRef as ReactComponent };